import React from "react";
import PropTypes from "prop-types";

const IndicativePredictionCell = ({ database, customStyle }) => {
  if (!Object.keys(database || {}).length) return null;
  return (
    <>
      <div style={customStyle} />
      {database?.indicativePrediction?.length > 0 && (
        <span data-testid="indicative_prediction" style={{ color: "#818a91" }}>
          {database?.indicativePrediction?.join(", ")}
        </span>
      )}
    </>
  );
};

IndicativePredictionCell.propTypes = {
  database: PropTypes.shape({
    indicativePrediction: PropTypes.arrayOf(PropTypes.string),
  }),
  customStyle: PropTypes.shape({}),
};

IndicativePredictionCell.defaultProps = {
  database: {},
  customStyle: {},
};

export default IndicativePredictionCell;
